import React from 'react';
import { Alert, Card, Loader } from '@unmind/design-system';
import { Trans, useTranslation } from 'react-i18next';
import { BookIcon } from 'Book/shared';
import { Form } from './components';
import { getTextPath } from './lib';
import { useBookServiceAccess } from './hooks';
import { Section, CardService, CardServiceIntro } from './Service.styles';

export default () => {
  const { t } = useTranslation<'book'>('book');
  const { loading, error, bookableService, serviceSlug } =
    useBookServiceAccess();

  if (loading) {
    return (
      <Section className="wrapper">
        <Loader />
      </Section>
    );
  }

  if (error || !bookableService) {
    return (
      <Section className="wrapper">
        <Alert
          title={t(`service.errors.${error ? 'fetch' : 'unauthorized'}`)}
          size="small"
          variant="error"
        />
      </Section>
    );
  }

  return (
    <Section className="wrapper">
      <CardService element="article" styling="no-border">
        <CardServiceIntro
          tone="nested"
          styling="no-border"
          className={serviceSlug}
        >
          <BookIcon icon={serviceSlug} width={32} height={32} />
          <h1>
            {bookableService?.name || t(getTextPath(serviceSlug, 'title'))}
          </h1>
          <p>{t(getTextPath(serviceSlug, 'subtitle'))}</p>
        </CardServiceIntro>

        {bookableService.isScreening && (
          <Alert
            title={t(getTextPath(serviceSlug, 'info.title'))}
            body={t(getTextPath(serviceSlug, 'info.body'))}
            size="small"
            style="no-border"
            variant="info"
          />
        )}

        <Trans
          t={t}
          i18nKey={getTextPath(serviceSlug, 'text')}
          components={{
            title: <p className="title" />,
            strong: <strong />,
            p: <p />,
            ul: <ul />,
            li: <li />,
          }}
        />
      </CardService>

      <Card element="section" styling="no-border" className="formcard">
        <Form service={bookableService} />
      </Card>
    </Section>
  );
};
